import { useState } from "react";
import { toast } from "sonner";
import { useAuth } from "../../context/AuthContext";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";

function fmtDetail(detail) {
  if (!detail) return "Login failed. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function AdminLogin() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
    } catch (err) {
      toast.error(fmtDetail(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="admin-login" className="min-h-screen bg-navy flex items-center justify-center px-4 relative overflow-hidden">
      <div className="absolute inset-0 eng-grid" />
      <div className="relative w-full max-w-sm">
        <div className="text-center mb-8">
          <span className="inline-block bg-brand text-white font-heading font-black text-2xl px-4 py-1.5 rounded-sm">PR7</span>
          <h1 className="font-heading font-extrabold text-white text-xl tracking-wide mt-4">MOT CENTRE ADMIN</h1>
          <p className="text-pale/50 text-xs mt-1.5 tracking-wide">Authorised access only</p>
        </div>
        <form data-testid="admin-login-form" onSubmit={submit} className="bg-deep/60 backdrop-blur border border-deep rounded-lg p-7 space-y-4">
          <div>
            <Label htmlFor="ad-email" className="text-xs font-heading font-bold uppercase tracking-wider text-pale/70">Email</Label>
            <Input
              id="ad-email" data-testid="admin-email" type="email" required autoComplete="email"
              value={email} onChange={(e) => setEmail(e.target.value)}
              className="bg-navy/70 border-deep text-white h-11 mt-1.5"
            />
          </div>
          <div>
            <Label htmlFor="ad-pass" className="text-xs font-heading font-bold uppercase tracking-wider text-pale/70">Password</Label>
            <Input
              id="ad-pass" data-testid="admin-password" type="password" required autoComplete="current-password"
              value={password} onChange={(e) => setPassword(e.target.value)}
              className="bg-navy/70 border-deep text-white h-11 mt-1.5"
            />
          </div>
          <button type="submit" data-testid="admin-login-btn" disabled={busy} className="btn-primary w-full justify-center disabled:opacity-60">
            {busy ? "SIGNING IN..." : "SIGN IN"}
          </button>
        </form>
      </div>
    </div>
  );
}
